module.exports = __webpack_public_path__ + "statics/img/SellAnywhere-3.1f22e1a6.png";